import { styled } from '@mui/material/styles';
import Tab, { tabClasses } from '@mui/material/Tab';

const PillTab = styled(Tab)(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 400,
  lineHeight: '1.25',
  borderRadius: 8,
  zIndex: 1,
  minHeight: 36,
  color: theme.palette.primary.dark,
  [`&.${tabClasses.selected}`]: {
    fontWeight: 500,
    color: theme.palette.primary.dark,
  },
  [`&.${tabClasses.root}`]: {
    padding: theme.spacing(0, 1.5),
  },
}));

export default PillTab;
